import { render, staticRenderFns } from "./AprovarDadosModal.vue?vue&type=template&id=65e5feb4&scoped=true"
import script from "./AprovarDadosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AprovarDadosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AprovarDadosModal.vue?vue&type=style&index=0&id=65e5feb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5feb4",
  null
  
)

export default component.exports